const state = {
	parsedText: {
		isDisplay: [
			{ value: 0, text: '미노출' },
			{ value: 1, text: '노출' },
		],
		isDiscontinue: [
			{ value: 1, text: '단종' },
			{ value: 0, text: '정상' },
		],
	},
	maxAttachProductLength: 5,
};

const getters = {
	parsedText: state => (type, targetValue) => {
		return state.parsedText[type].find(({ value }) => value === targetValue)
			?.text;
	},
};

export default {
	namespaced: true,
	state,
	getters,
};
